import Vue from "vue";
import VueRouter from "vue-router";
import TabBarMainLayout from "@/core/layouts/BasicLayout.vue";
import UserLayout from "@/core/layouts/UserLayout.vue";
import FullScreenLayout from "@/core/layouts/FullScreenLayout.vue";
import NoTabberLayout from "@/core/layouts/NoTabberLayout.vue";
import storeBase from "@/store";

Vue.use(VueRouter);

export const store = storeBase;

const dynamicWrapper = (modules = [], component) => {
  if (modules.length > 0) {
    modules.forEach(module => {
      const m = require(`@/pages/${module}`).default; // eslint-disable-line
      const { name = "default" } = m;
      store.registerModule(name, m);
    });
  }

  return component;
};
const page404 = {
  path: "/*",
  name: "e-404",
  title: "404",
  redirect: "/exception/404"
};

const exceptionRouter = {
  path: "/exception",
  name: "exception",
  title: "exception",
  redirect: "/exception/404",
  component: TabBarMainLayout,
  children: [
    {
      path: "404",
      name: "404",
      meta: {
        title: "404"
      },
      component: dynamicWrapper([], () => import("@/pages/Exception/route/404"))
    },
    {
      path: "403",
      name: "403",
      meta: {
        title: "403"
      },
      component: dynamicWrapper([], () => import("@/pages/Exception/route/403"))
    },
    {
      path: "500",
      name: "500",
      meta: {
        title: "500"
      },
      component: dynamicWrapper([], () => import("@/pages/Exception/route/500"))
    }
  ]
};
const userRouter = {
  path: "/user",
  name: "user",
  title: "user",
  redirect: "/user/login",
  component: UserLayout,
  // beforeEnter(to, from, next) {
  //   // console.log("to1", to);
  //   const token = localStorage.getItem("token");
  //   // console.log("token", token);
  //   if (to.fullPath === "/user/login" && token) {
  //     next({ path: "/" });
  //   } else {
  //     next();
  //   }
  // },
  children: [
    {
      path: "login",
      name: "login",
      meta: {
        title: "授权"
      },
      component: dynamicWrapper(["Login/module"], () => import("@/pages/Login/route"))
    },
    {
      path: "exchangeEecord",
      name: "exchangeEecord",
      meta: {
        title: "兑换记录"
      },
      component: dynamicWrapper(["ExchangeEecord/module"], () => import("@/pages/ExchangeEecord/route"))
    },
    {
      path: "expressHistory",
      name: "expressHistory",
      meta: {
        title: "兑换记录"
      },
      component: dynamicWrapper(["ExpressHistory/module"], () => import("@/pages/ExpressHistory/route"))
    },
  ]
};


const basicRouter = [
  {
    path: "/",
    component: FullScreenLayout,
    children: [
      {
        path: "",
        name: "entry",
        meta: {
          title: '首页',
          requiresAuth: false
        },
        component: dynamicWrapper(["Entry/module"], () => import("@/pages/Entry/route"))
        // component: dynamicWrapper(["Home/module"], () => import("@/pages/Home/route"))
      },
      {
        path: "start",
        name: "start",
        meta: {
          title: '兑换礼品',
          requiresAuth: false
        },
        component: dynamicWrapper(["Start/module"], () => import("@/pages/Start/route"))
      },
      {
        path: "giftlist",
        name: "giftlist",
        meta: {
          title: '选择礼品',
          requiresAuth: false
        },
        component: dynamicWrapper(["GiftList/module"], () => import("@/pages/GiftList/route"))
      },
      {
        path: "input",
        name: "input",
        meta: {
          title: '填写收货信息',
          requiresAuth: false
        },
        component: dynamicWrapper(["Input/module"], () => import("@/pages/Input/route"))
      },
      {
        path: "giftDetail",
        name: "giftDetail",
        meta: {
          title: '礼品详情',
          requiresAuth: false
        },
        component: dynamicWrapper(["GiftDetail/module"], () => import("@/pages/GiftDetail/route"))
      },
      // {
      //   path: "/personalCenter",
      //   name: "PersonalCenter",
      //   meta: {
      //     title: "个人中心",
      //     requiresAuth: true
      //   },
      //   component: dynamicWrapper(
      //     ["PersonalCenter/module"],
      //     () => import("@/pages/PersonalCenter/route")
      //     // eslint-disable-next-line function-paren-newline
      //   )
      // }
    ]
  },
];

const routers = [...basicRouter, userRouter, exceptionRouter, page404];
// 路由配置
const RouterConfig = {
  mode: "history",
  base: "/",
  routes: routers,
  scrollBehavior() {
    return { x: 0, y: 0 };
  }
};
const router = new VueRouter(RouterConfig);

router.beforeEach((to, from, next) => {
  // console.log("to", to);
  const token = localStorage.getItem("token");

  if (to.meta.title) {
    document.title = to.meta.title
  }

  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!token) {
      next({
        path: "/user/login"
      });
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router;
